import { useState, useCallback } from "react";
import { AgGrid } from "@jsq/ds/core";
import type { BillingCaseRowItem } from "../types";

export const useCaseSlideoutDrawer = () => {
  const [selectedCase, setSelectedCase] = useState<BillingCaseRowItem | undefined>(undefined);

  const onCellClicked = useCallback((event: AgGrid.CellClickedEvent<BillingCaseRowItem>) => {
    if (event.data) {
      setSelectedCase(event.data);
    }
  }, []);

  const onClose = useCallback(() => {
    setSelectedCase(undefined);
  }, []);

  return { selectedCase, onClose, onCellClicked };
};
